module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_2.f613aa38.jpg";